import * as React from "react";

interface LoggedInMagentoUiConsumerInterface {
  presentLoggedInMagentoUi: () => Promise<unknown>;
}
const defaultValue = {} as unknown as LoggedInMagentoUiConsumerInterface;
const LoggedInMagentoUiContext = React.createContext(defaultValue);

export const LoggedInMagentoUiProvider: React.FunctionComponent = (props) => {
  const presentLoggedInMagentoUi = React.useCallback(async () => {
    return new Promise((resolve) => {
      (window.require as any)(["jquery"], function ($: any) {
        const headerLoggedInUiSection = `
            <ul class="logged-in-user">
              <li class="customer-welcome">
                <div
                  class="customer-name"
                >
                  <div class="name">My Account</div>
                  <button
                    type="button"
                    class="action switch"
                    tabindex="-1"
                    data-action="customer-menu-toggle"
                  >
                    <span>Change</span>
                  </button>
                </div>

                <script type="text/x-magento-init">
                  {
                      "*": {
                          "Magento_Ui/js/core/app": {
                              "components": {
                                  "customer": {
                                      "component": "Magento_Customer/js/view/customer"
                                  }
                              }
                          }
                      }
                  }
                </script>
              </li>
            </ul>
          `;

        const mobileHamburgerMenuLoggedInUi = `
          <li class="level0 level-top nav--with-submenu customer-menu-mobile">
            <a href="#" class="level-top user-name" data-bind="scope: 'customer'">
              <span class="name-container"> My Account </span>
            </a>
            <button class="submenu-sticky-header">My Account</button>
            <div class="level0 submenu">
              <div class="level0 submenu-content">
                <div class="column">
                  <ul class="column__links-list">
                    <li class="nav item">
                      <a href="/customer/account/">My Account</a>
                    </li>
                    <li class="nav item">
                      <a href="/sales/order/history/">My Orders</a>
                    </li>
                    <li class="nav item">
                      <a href="/wishlist/">My Wish List</a>
                    </li>
                    <li class="nav item">
                      <a href="/customer/address/">Address Book</a>
                    </li>
                    <li class="nav item">
                      <a href="/customer/account/edit/"
                        >Account Information</a
                      >
                    </li>
                    <li class="nav item">
                      <a href="/giftcard/customer/"
                        >Check Your Gift Card Balance</a
                      >
                    </li>
                    <li class="nav item">
                      <a href="/customer/account/logout/">Logout</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <script type="text/x-magento-init">
                  {
                      "*": {
                          "Magento_Ui/js/core/app": {
                              "components": {
                                  "customer": {
                                      "component": "Magento_Customer/js/view/customer"
                                  }
                              }
                          }
                      }
                  }
              </script>
              <script type="text/x-magento-init">
                  {
                      ".nav-sections": {
                          "mobileUserAccountMenu": {}
                      }
                  }
              </script>
          </li>
        `;

        const selectorFor_desktopHeaderMenu =
          ".header-container-sticky > .header.content > .header-extras";
        const partialSelectorFor_theWishlistOptionInTheDesktopHeaderMenu =
          "> .wishlist-header-container";
        const selectorFor_whereToInsertHeaderLoggedInUiSectionAfter = `${selectorFor_desktopHeaderMenu} ${partialSelectorFor_theWishlistOptionInTheDesktopHeaderMenu}`;
        const partialSelectorFor_theNewHeaderLoggedInUiSection =
          "> .logged-in-user";
        const selectorFor_theNewHeaderLoggedInUiSection = `${selectorFor_desktopHeaderMenu} ${partialSelectorFor_theNewHeaderLoggedInUiSection}`;

        $(headerLoggedInUiSection).insertAfter(
          selectorFor_whereToInsertHeaderLoggedInUiSectionAfter
        );
        $(selectorFor_theNewHeaderLoggedInUiSection).trigger("contentUpdated");

        const selectorFor_mobileHamburgerMenu_navMenuList =
          ".sections.nav-sections > .nav-sections-items > .nav-sections-item-content > nav > .nav-menu-list";
        const partialSelectorFor_theAccountItemInTheNavMenuList =
          ".level0.level-top.nav--with-submenu.authorization-link-mobile";
        const selectorFor_theAccountItemInTheNavMenuList = `${selectorFor_mobileHamburgerMenu_navMenuList} ${partialSelectorFor_theAccountItemInTheNavMenuList}`;
        const partialSelectorFor_theNewAccountItemInTheNavMenuList =
          ".level0.level-top.nav--with-submenu.customer-menu-mobile";
        const selectorFor_theNewAccountItemInTheNavMenuList = `${selectorFor_mobileHamburgerMenu_navMenuList} ${partialSelectorFor_theNewAccountItemInTheNavMenuList}`;

        $(selectorFor_theAccountItemInTheNavMenuList).replaceWith(
          mobileHamburgerMenuLoggedInUi
        );
        $(selectorFor_theNewAccountItemInTheNavMenuList).trigger(
          "contentUpdated"
        );

        resolve(true);
      });
    });
  }, []);

  const value: LoggedInMagentoUiConsumerInterface = React.useMemo(
    () => ({ presentLoggedInMagentoUi }),
    []
  );

  return (
    <LoggedInMagentoUiContext.Provider value={value}>
      {props.children || []}
    </LoggedInMagentoUiContext.Provider>
  );
};

export const useLoggedInMagentoUi = () => {
  const context = React.useContext(LoggedInMagentoUiContext);
  if (context === defaultValue) {
    throw new Error(
      "useLoggedInMagentoUi must be used within a LoggedInMagentoUiProvider"
    );
  }
  return context;
};
